/**
 * Hook para Validação de Campos
 */

import {
  validateEmail,
  validatePhone,
  validateCPF,
  validateCEP,
  validateDate,
  validateRG,
  validateInstagram,
  validateText,
  validateField,
} from '../validators';

export const useFormValidation = () => {
  return {
    validateEmail,
    validatePhone,
    validateCPF,
    validateCEP,
    validateDate,
    validateRG,
    validateInstagram,
    validateText,
    validateField,
  };
};
